import defaultTheme from './defaultTheme';
const jcrewTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#00853e', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#00853e', background: '#00853e' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#00853e', outline: '#FFFFFF' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#00853e', border: '#00853e', background: '#00853e' }), field: {
        focus: '#00853e',
        label: '#00853e',
        icon: '#00853e',
    } });
export default jcrewTheme;
